export default {
  "Audio Compressor": "Kompresor Audio",
  "HitPaw Online Audio Compressor": "HitPaw Online Kompresor Audio",
  "Reduce audio file size online without quality loss.": "Kurangi ukuran file audio online tanpa mengurangi kualitas.",
  "Compress": "Kompres",
  "Compressing": "Mengompres",
  "Compressed Successfully": "Berhasil Dikompres",
  "Compress New": "Kompres Baru",
  "Compression is complete": "Kompresi selesai",
  "Compression failed": "Kompresi gagal",
  "Quality": "Kualitas",
  "Format": "Format",
  "Add file": "Tambah file",
  "Output Settings": "Pengaturan Output",

};
